import { Global, css } from "@emotion/react";
import { useEffect, useState } from "react";

/** Two shared native paints, decoded once on HDR displays; failed loads retain SDR text. */
export function HdrHighlights() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!CSS.supports("background-clip", "text")) return;
    const media = matchMedia("(dynamic-range: high)");
    let active = true;
    async function update() {
      setReady(false);
      if (!media.matches) return;
      try {
        await Promise.all(
          ["gold", "ivory"].map(async (tone) => {
            const image = new Image();
            image.src = `/hdr/${tone}32.avif`;
            await image.decode();
          }),
        );
        if (active && media.matches) setReady(true);
      } catch {
        // Ordinary opaque text stays readable when optional HDR paint cannot decode.
      }
    }
    void update();
    media.addEventListener("change", update);
    return () => {
      active = false;
      media.removeEventListener("change", update);
    };
  }, []);
  if (!ready) return null;
  return (
    <Global
      styles={css`
        @media (dynamic-range: high) {
          [data-hdr-tone][data-hdr-tone] {
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            text-shadow: none;
          }
          [data-hdr-tone="gold"] {
            background-image: url("/hdr/gold32.avif");
          }
          [data-hdr-tone="ivory"] {
            background-image: url("/hdr/ivory32.avif");
          }
          [data-hdr-surface="gold"] {
            background-image: url("/hdr/gold32.avif");
            background-size: 100% 100%;
          }
          @media (forced-colors: active) {
            [data-hdr-tone][data-hdr-tone] {
              background-image: none;
              color: CanvasText;
              -webkit-text-fill-color: CanvasText;
            }
          }
        }
      `}
    />
  );
}
